import gql from 'graphql-tag';

export const registerBse = gql`
  mutation register(
    $operationNumber: Float!
    $origin: String!
    $UT: Boolean
    $fields: [FieldFormToBSE!]!
  ) {
    saveFormBSE(
      parameters: {
        operationNumber: $operationNumber
        origin: $origin
        fields: $fields
        UT: $UT
      }
    ) {
      status
      operationNumber
    }
  }
`;
